import {Routes} from "@angular/router";
import {SettingsPage} from "./page/settings/settings.page";

export function UsSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

     // {path: 'us', component: SettingsPage },

  ];

  return routes;

}
